package org.ksdfv.thelema.fs

import kotlin.native.concurrent.ThreadLocal

/** File system abstraction layer. It is singleton and you can use it anywhere after initialization.
 * If you want multiple APIs, you may switch between them by setting.
 * By default used JVM file system implementation.
 * @author zeganstyl */
@ThreadLocal
object FS: IFileSystem {
    const val ReadAccessFlag = 1
    const val WriteAccessFlag = 2

    lateinit var proxy: IFileSystem

    override val externalStoragePath: String
        get() = proxy.externalStoragePath
    override val isExternalStorageAvailable: Boolean
        get() = proxy.isExternalStorageAvailable
    override val localStoragePath: String
        get() = proxy.localStoragePath
    override val isLocalStorageAvailable: Boolean
        get() = proxy.isLocalStorageAvailable

    override fun file(path: String, location: Int): IFile = proxy.file(path, location)
}
